<main class="h-svh text-base">
  <router-outlet />
</main>
